var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQueueBpjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 225,
    viewBox: "0 0 281 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15_34)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.801 132.131L133.799 120.473H119.327V104.393H126.161L113.431 92.8691L101.238 104.259H107.536V123.555C107.536 129.585 108.608 132.265 113.833 132.265L120.935 132.131H120.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.197 92.8691L147.199 104.527H161.671V120.607H154.837L167.567 132.131L179.761 120.741H173.463V101.445C173.463 95.4151 172.391 92.7351 167.165 92.7351L160.063 92.8691H160.197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.198 132.265L148.54 119.267V133.739H132.46V126.905L120.936 139.635L132.326 151.829V145.531H151.622C157.652 145.531 160.332 144.459 160.332 139.233L160.198 132.131V132.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.937 92.869L132.595 105.867V91.395H148.675V98.229L160.199 85.499L148.809 73.3051V79.6031H129.513C123.483 79.6031 120.803 80.6751 120.803 85.901L120.937 93.003V92.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8109 76.5212C67.2029 79.2012 65.7289 79.2012 64.5229 90.3231C63.3169 101.579 70.4189 113.371 70.4189 113.371C70.4189 113.371 69.7489 108.011 73.0988 103.455C76.4488 99.0331 83.2828 92.3331 86.4988 87.9111C89.7147 83.4892 90.5187 77.7272 90.5187 77.7272C87.5708 79.0672 84.3548 79.7372 80.8708 79.7372C76.4488 79.7372 72.4288 78.5312 68.8109 76.3872V76.5212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.3522 56.8233C97.3522 65.9353 89.9823 73.3052 80.8703 73.3052C71.7584 73.3052 64.3884 65.9353 64.3884 56.8233C64.3884 47.7114 71.7584 40.3414 80.8703 40.3414C89.9823 40.3414 97.3522 47.7114 97.3522 56.8233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6298 43.0214C99.6298 43.0214 112.36 33.9094 125.09 32.0335C137.82 30.2915 156.044 33.3734 156.044 33.3734C156.044 33.3734 147.2 34.0434 141.706 37.2594C136.212 40.4754 131.924 45.4334 125.358 51.1953C118.926 57.0913 114.236 60.8433 109.68 62.9873C106.732 64.3273 104.186 64.7293 102.712 64.7293C103.65 62.3173 104.052 59.6373 104.052 56.8233C104.052 51.5973 102.31 46.7734 99.4958 42.8874L99.6298 43.0214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.258 184.926C107.938 186.534 107.938 188.008 119.06 189.214C130.316 190.42 142.108 183.319 142.108 183.319C142.108 183.319 136.748 183.989 132.192 180.639C127.77 177.289 121.07 170.455 116.648 167.239C112.226 164.023 106.464 163.219 106.464 163.219C107.804 166.167 108.474 169.383 108.474 172.867C108.474 177.289 107.268 181.309 105.124 184.926H105.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.695 156.519C94.807 156.519 102.177 163.889 102.177 173.001C102.177 182.113 94.807 189.482 85.695 189.482C76.5831 189.482 69.2131 182.113 69.2131 173.001C69.2131 163.889 76.5831 156.519 85.695 156.519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7585 154.241C71.7585 154.241 62.6465 141.511 60.7705 128.781C59.0285 116.051 62.1105 97.8271 62.1105 97.8271C62.1105 97.8271 62.7805 106.671 65.9965 112.165C69.2125 117.659 74.1704 121.947 79.9324 128.513C85.8284 134.945 89.5803 139.635 91.7243 144.191C93.0643 147.139 93.4663 149.685 93.4663 151.159C91.0543 150.221 88.3744 149.819 85.5604 149.819C80.3344 149.819 75.5104 151.561 71.6245 154.375L71.7585 154.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.19 148.479C213.798 145.799 215.272 145.799 216.478 134.677C217.684 123.421 210.582 111.629 210.582 111.629C210.582 111.629 211.252 116.989 207.902 121.545C204.552 125.967 197.718 132.667 194.502 137.089C191.286 141.511 190.482 147.273 190.482 147.273C193.43 145.933 196.646 145.263 200.13 145.263C204.552 145.263 208.572 146.469 212.19 148.613V148.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.782 168.176C183.782 159.065 191.152 151.695 200.264 151.695C209.376 151.695 216.746 159.065 216.746 168.176C216.746 177.288 209.376 184.658 200.264 184.658C191.152 184.658 183.782 177.288 183.782 168.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.503 181.979C181.503 181.979 168.773 191.091 156.043 192.967C143.313 194.709 125.09 191.627 125.09 191.627C125.09 191.627 133.934 190.957 139.428 187.741C144.921 184.525 149.209 179.567 155.775 173.805C162.207 167.909 166.897 164.157 171.453 162.013C174.401 160.673 176.947 160.271 178.421 160.271C177.483 162.683 177.081 165.363 177.081 168.177C177.081 173.403 178.823 178.227 181.637 182.113L181.503 181.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.742 40.0733C173.062 38.4653 173.062 36.9913 161.94 35.7853C150.684 34.5793 138.892 41.6812 138.892 41.6812C138.892 41.6812 144.252 41.0112 148.808 44.3612C153.23 47.7112 159.93 54.5452 164.352 57.7611C168.774 60.9771 174.536 61.7811 174.536 61.7811C173.196 58.8331 172.526 55.6172 172.526 52.1332C172.526 47.7112 173.732 43.6912 175.876 40.0733H175.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.44 68.4811C186.328 68.4811 178.958 61.1112 178.958 51.9992C178.958 42.8873 186.328 35.5173 195.44 35.5173C204.552 35.5173 211.922 42.8873 211.922 51.9992C211.922 61.1112 204.552 68.4811 195.44 68.4811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.242 70.7593C209.242 70.7593 218.354 83.4892 220.23 96.2192C221.972 108.949 218.89 127.173 218.89 127.173C218.89 127.173 218.22 118.329 215.004 112.835C211.788 107.341 206.83 103.053 201.068 96.4872C195.172 90.0552 191.42 85.3652 189.276 80.8092C187.936 77.8613 187.534 75.3153 187.534 73.8413C189.946 74.7793 192.626 75.1813 195.44 75.1813C200.666 75.1813 205.49 73.4393 209.376 70.6253L209.242 70.7593Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15_34",
    x: 45.2371,
    y: 23.5,
    width: 190.526,
    height: 192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.454902 0 0 0 0 0.733333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_34"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15_34",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQueueBpjs);
export default __webpack_public_path__ + "static/media/icon_queue_bpjs.2ae29e23dda734dfa0b35d5ccdcd78ea.svg";
export { ForwardRef as ReactComponent };